<template>
  <svg class="icon svg-icon"
    aria-hidden="true">
    <use :xlink:href="'#icon-' + name"></use>
  </svg>
</template>

<script>
import './iconfont.js'
import './iconfont_credit.js'
import './iconfont_laboratory.js'
import './icon.css'
export default {
  props: {
    name: {
      required: true,
      type: String
    }
  }
}
</script>


// WEBPACK FOOTER //
// ../vue-common-laboratory/src/components/icons/index.vue